class AddToCart extends Component {
    constructor(el) {
        super(el);

        this.form = this.$find('form');
        this.type = this.$el.dataset.type;

        this.addEventListeners();
    }

    addToCart() {
        const formData = new FormData(this.form);
        formData.append('ajax', '1');

        fetch(this.form.getAttribute('action'), {
            method: 'POST',
            body: formData,
        })
            .then(response => response.json())
            .then(data => this.onCartAdded(data))
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    onCartAdded(data) {
        EventBus.getInstance().dispatchEvent('cartUpdated', data);
    }

    showInquiry() {
        EventBus.getInstance().dispatchEvent('showInquiry', {
            url: this.inquiryUrl + '?' + new URLSearchParams(new FormData(this.form)).toString() + '&ajax=1'
        });
    }

    onFormSubmit(e) {
        e.preventDefault();

        EventBus.getInstance().dispatchEvent('showGlobalSpinner');

        if(this.type === 'cart') {
            this.addToCart();
        } else if (this.type === 'inquiry') {
            this.showInquiry();
        }
    }

    addEventListeners() {
        this.form.addEventListener('submit', e => this.onFormSubmit(e));
    }
}